/*
 * Copyright © 2017-2026 Knowledge for Decisions (K4D). All rights reserved.
 */

import React from 'react';
import { InfoCircledIcon } from "@radix-ui/react-icons";
import Card from '../../basic/card/Card';
import { zIndex } from '@/shared/themes/light/z-index';

type InfoButtonProps = { text: string };

/**
 * Hover-reveal tooltip button with an info icon.
 *
 * @param {InfoButtonProps} props - Info button properties.
 * @returns {JSX.Element} Rendered tooltip button.
 */
export const InfoButton: React.FC<InfoButtonProps> = ({ text }) => {
  return (
    <div className="relative cursor-help group">
      <InfoCircledIcon className="text-[var(--text-primary)] mx-1" />
      <Card
        addOutline
        size="micro"
        className="absolute top-0 right-full h-0 w-0 p-0 opacity-0 overflow-hidden transition-all text-sm group-hover:opacity-100 group-hover:h-auto group-hover:w-max group-hover:max-w-[200px] group-hover:p-2"
        style={{ zIndex: zIndex.popup }}
      >
        {text}
      </Card>
    </div>
  );
};
